import { NgModule, Component, OnInit } from '@angular/core';
import { UpsCommonService } from '../../services/upplm.common.service';
import { UpplmApiService } from '../../services/upplm.api.services';
import { ConfigurationService } from '../../services/upplm.configuration.service';
import { COOKIES_TO_GET, ServiceURLConstants, ApiErrorCode, ENVIRONMENTS, RouteURLConstants } from '../../constants/upplm.constants';
import { QVCookie, qvSummariesRequest, qvSummariesResponse } from '../../interface/upplm.qvSummaries';

@Component({
    selector: 'templatedashboard',
    template: require('./template-dashboard.component.html')
})
/** templateDashboard component*/
export class TemplateDashboardComponent implements OnInit {
    public isDashboard: boolean = true;
    public isQvDashboard: boolean = false;
    public qvSummryRequest: qvSummariesRequest;
    /** templateDashboard ctor */
    constructor(
        private _commonService: UpsCommonService,
        private _apiService: UpplmApiService,
        private _configurationService: ConfigurationService
    ) {
        this.qvSummryRequest = new qvSummariesRequest();
    }

    ngOnInit() {
        var dt = new Date();
        this.qvSummryRequest.startDate = new Date(dt.getTime() - 1000 * 60 * 60 * 24 * 30).toString();
        this.qvSummryRequest.startDate = this.formatDate(new Date(this.qvSummryRequest.startDate));
        this.qvSummryRequest.endDate = this.formatDate(new Date(Date.now()));
        this.getCookies(COOKIES_TO_GET.SESSION_UPS_COM);

    }
    public formatDate(fDate) {
        let dateFormated = "";
        if (this.qvSummryRequest.startDate != "") {
            let day = fDate.getDate();
            day = day < 10 ? "0" + day : day;
            let month = fDate.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            let year = fDate.getFullYear();
            dateFormated = year + "-" + month + "-" + day;
        }

        return dateFormated;
    }

    public getCookies(cookieLooking) {
        var qvCookie = new QVCookie();
        qvCookie.name = cookieLooking;
        let url = this._commonService.createURL(ServiceURLConstants.GET_QVSUMMARIES_COOKIES, ApiErrorCode.GET_QVSUMMARIES_COOKIES);
        this._apiService.PostServiceAPI(url,
            qvCookie).
            subscribe((response: any) => {
                if (response == null || response == '' || response == undefined) {
                    if (this._configurationService.appSettings.environment === ENVIRONMENTS.Development || this._configurationService.appSettings.environment === ENVIRONMENTS.CDE) {
                        this.qvSummryRequest.username = this._configurationService.appSettings.userName;
                        //startDate: 2022 - 10 - 12
                        //endDate: 2023 - 04 - 16
                        this.callApiGetSummaries();
                    } else {
                        this.isDashboard = true;
                        return false;
                    }
                } else {
                    this.qvSummryRequest.username = '';
                    this.qvSummryRequest.cookie = 'session_ups_com=' + response;
                    this._configurationService.appSettings.cookie = this.qvSummryRequest.cookie;
                    this.callApiGetSummaries();
                }
            });
    }

    public callApiGetSummaries() {
        let url = this._commonService.createURL(ServiceURLConstants.GET_QVSUMMARIES, ApiErrorCode.GET_QVSUMMARIES);
        this._apiService.PostServiceAPI(url, this.qvSummryRequest).
            subscribe((response: qvSummariesResponse) => {
                if (response.errors) {
                    if (response.errors[0].code == '0002') {
                        this.isDashboard = true;
                    }
                    //Handle errors
                } else {
                    var responseModel = response;
                    if (response.summary.totalClientKeys.length > 0) {
                        this.isDashboard = false;
                    } else {
                        this.isDashboard = true;
                    }
                }
            });
    }
}